// extracted by mini-css-extract-plugin
export default {"footerBg":"ma-z","footerTopLinks":"na-z","footerFeedback":"oa-z","footerSocial":"pa-z","footerLegalLinks":"qa-z","footerIconCards":"ra-z","footerBotCopy":"sa-z"};